import styled from 'styled-components';
import { getColor, Theme } from 'styles/theme';
import { getIcon } from 'styles/icons';
import { breakpoint } from 'styles/globals';

export const NextArrowWrapper = styled.button<{ theme: Theme }>`
  width: 40px;
  height: 40px;
  border: 1px solid ${getColor('borderSecondary')};
  background-color: ${getColor('surfaceSecondary')};
  border-radius: 100%;
  cursor: pointer;
  content: '';

  &.slick-next::before {
    display: none;
  }
    
  &.slick-next {
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0;
  }

  &.slick-disabled {
    .next-shade {
      display: none;
    }
  }
`;

export const NextArrow = styled.span<{ theme: Theme }>`
  ${getIcon('next-arrow', 'default')};
  margin-right: 3px;
  margin-top: 1px;
`;

export const NextButtonShaded = styled.div<{ theme: Theme }>`
  background-image: linear-gradient(to right,  rgba(255, 255, 255, 0.00) 0%,  rgba(255, 255, 255, 1) 100%);
  width: 70px;
  height: 100%;
  
  position: absolute;
  right: -17px;
  top: 0;
  transform: none;
  display: none;
  
  @media (${breakpoint.mdMin}) {
    display: block;
  }

  &::before {
    display: none;
  }

  &.slick-disabled {
    display: none;
  }
`;
